import TimelineLite from 'gsap/TimelineLite';
import HtmlHelper from './html-helper';
import template from '../html/default-modal.hbs'
import ModalController from "./modal-controller";

let elementModalProperty = Symbol.for("modalProperty");

export default class Modal {

    static create(content) {

        let fromString = false;

        //create element if we got a string here
        if (typeof content === 'string') {
            fromString = true;
            content = HtmlHelper.createElement(content);
        }

        if (!HtmlHelper.isHtmlElement(content)) {
            throw new Error('HTMLElement or string are allowed');
        }

        if (fromString) {
            //if we previously create element from string
            //we need to add it to DOM, so pass it through spicific method
            //todo: check if current document and element's document are the same
            if(content.classList.contains(Modal.className)){
                //if content is a modal element
                return Modal.createFromElement(content);
            }else{
                //if content is a modal content element
                return Modal.createFromContentElement(content);
            }
        } else {
            let actualModalElement = HtmlHelper.getElementParentWithClass(content, Modal.className);
            //simple check is it just a content of modal
            // or a whole modal element (current element or it's parent)
            if (actualModalElement) {
                return new Modal(actualModalElement);
            } else {
                return Modal.createFromContentElement(content);
            }
        }
    }

    static createFromContentElement(contentElement) {
        if (!HtmlHelper.isHtmlElement(contentElement)) {
            throw new Error('HTMLElement or string are allowed');
        }

        let modalElement = HtmlHelper.createElement(template());
        let modalContentElement = modalElement.querySelector('.js-modal-content');
        modalContentElement.insertAdjacentElement('beforeend', contentElement);

        return Modal.createFromElement(modalElement);
    }

    static createFromElement(modalElement) {
        document.body.insertAdjacentElement('beforeend', modalElement);
        return new Modal(modalElement);
    }

    constructor(element) {
        if (!element) {
            throw new Error('element should be valid HTMLElement instance');
        }

        if (element[elementModalProperty]) {
            return element[elementModalProperty];
        } else {
            element[elementModalProperty] = this;
        }

        this.controller = ModalController.getInstance();
        this.element = element;
        this.closeElements = [...this.element.querySelectorAll('.js-modal-close')];
        this.wrapperElement = this.element.querySelector('.js-modal-wrapper');

        this.tween = new TimelineLite({paused: true});
        this.tween.fromTo(this.element, 0.3, {opacity: '0'}, {opacity: '1'});

        this.reserseResolve = null;
        this.startResolve = null;

        this.tween.eventCallback('onStart', () => {
            this.element.classList.add('is-opened');
            if (this.startResolve) {
                this.startResolve();
            }
        });
        this.tween.eventCallback('onReverseComplete', () => {
            this.element.classList.remove('is-opened');
            if (this.reserseResolve) {
                this.reserseResolve();
            }
        });

        this.hasOpened = false;
    }

    open() {
        this.controller.open(this);
    }

    onOpen() {
        if (!this.hasOpened) {
            this.hasOpened = true;
            this.closeElements.forEach(el => el.addEventListener('click', this.close.bind(this)));
        }

        return new Promise((resolve) => {
            this.startResolve = resolve;
            this.tween.play();
        });
    }

    close() {
        this.controller.close(this);
    }

    onClose(fast = false) {
        return new Promise((resolve) => {
            this.reserseResolve = resolve;
            if (fast) {
                this.tween.timeScale(2);
            }
            this.tween.reverse();
        }).then(() => {
            if (fast) {
                this.tween.timeScale(1);
            }
        });
    }

    getElement() {
        return this.element;
    }

    getWrapperElement() {
        return this.wrapperElement;
    }
}
Modal.className = 'modal';



// WEBPACK FOOTER //
// ./app/general/js/modal.js